import React from 'react'
import DataGrid from 'react-data-grid'
import { useTranslation } from 'react-i18next'
import './index.css'

const Training: React.FC = () => {
    const { t } = useTranslation()
    // const navigate = useNavigate()
    const column = [
        {
            key: 'name',
            name: `${t('brand.tableColumns.name')}`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'date',
            name: `Date`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return <div className="trang-status">{props.row.status}</div>
            },
        },
    ]

    const rows = []

    for (let i = 0; i < 4; i++) {
        rows.push({
            name: 'Training Course 1',
            date: 'Jan 1 - Jan 14, 2024',
            status: 'Completed',
        })
    }

    return (
        <div>
            <div className="col-12 grid-custom-table grid-table-timeoff">
                <DataGrid
                    className="data-grid-table"
                    columns={column}
                    // rowKeyGetter={(row: Brand) => row.id}
                    rows={rows}
                    rowHeight={60}
                    headerRowHeight={40}
                    // onCellClick={(row) => {
                    //     setSelectedBrand(row.row)
                    // }}
                    // sortColumns={sortColumns}
                    // onSortColumnsChange={setSortColumns}
                />
            </div>
        </div>
    )
}

export default Training
